import type { CaseDetail } from '../portfolio';

const qSaiAojiruCase: CaseDetail = {
  id: 'q-sai-aojiru',
  project: 'Q-SAI 青汁 ブランド戦略・PROMOTION企画',
  client: 'Q-SAI',
  year: 'Archive',
  category: 'Brand Strategy / Promotion Planning / Package Design',
  role: 'Brand Strategy / Promotion Planning / Package Design',
  issue: '青汁商品としての認知拡大と、ブランド戦略による差別化。',
  challenge: '機能訴求だけではなく、ブランドとしての価値を構築すること。',
  insight: '健康志向の消費者に対して、ブランドのストーリーと価値を届ける。',
  strategy: 'ブランド戦略とPROMOTION企画を統合し、商品の魅力を最大化する。',
  experience: 'パッケージデザイン、プロモーション展開を通じた統一ブランド体験。',
  output: 'Brand Strategy / Promotion Plan / Package Design',
  impact: 'ブランド認知の向上と、プロモーション効果の最大化。',
  images: [
    {
      src: '/assets/migrated/e1eed88ed7cb0cbfdaa7.webp',
      caption: 'Q-SAI 青汁 ブランド戦略・PROMOTION企画 — 表紙',
    },
    {
      src: '/assets/migrated/7ce06770f6a6fe491d71.webp',
      caption: '消費者インサイト考察 — 買い場MR分析と同時に、課題解決に向けて「消費者インサイトからの考察」',
    },
    {
      src: '/assets/migrated/c9930b1a878ebd9b0ade.webp',
      caption: '消費者インサイトの分析視点 — 消費者インサイトから商品価値を引き出す分析視点と3方向性（A/B/C）',
    },
    {
      src: '/assets/migrated/726533f56090aff45ce6.webp',
      caption: '商品分析 — 競合から見ての商品分析 / キューサイ「青汁のある食卓」(はちみつ入り)',
    },
    {
      src: '/assets/migrated/be01b28221c668ec2c44.webp',
      caption: 'SWOT分析 — 商品分析と課題抽出 SWOT',
    },
    {
      src: '/assets/migrated/86c667112390024cf8b0.webp',
      caption: 'コミュニケーション設計 — コミュニケーション・タグライン / 設計のタッチポイント — Qサイの「青汁」を毎日続けてもらうコミュニケーション設計',
    },
    {
      src: '/assets/migrated/e7f12501fc3570b8a916.webp',
      caption: 'Appeal Point 抽出 — 競合他社 / Appeal Point / 抽出',
    },
    {
      src: '/assets/migrated/30667647ffd7719fae15.webp',
      caption: 'Appeal Point 抽出表 — 競合他社 / Appeal Point / 抽出表',
    },
    {
      src: '/assets/migrated/missing-transparent.gif',
      caption: 'Appeal Point 抽出（レシピ・はちみつ/ケール）— 競合他社 / Appeal Point / 抽出 — 青汁レシピ3種展開 / はちみつ・ケール追求',
    },
    {
      src: '/assets/migrated/256db84936c2354ebb19.webp',
      caption: 'ポジショニングMAP — 競合他社とのポジショニングMAP',
    },
    {
      src: '/assets/migrated/c80ed9a7a0f497354fe8.webp',
      caption: 'Communication Appeal Word — リテール訴求・はちみつ訴求・毎日の健康訴求（A/B/C）',
    },
    {
      src: '/assets/migrated/b44be5b15b82be960484.webp',
      caption: 'Appeal Point 抽出詳細 — A:リテールで原材料を分かり易く視覚化 / B:はちみつと一緒の意味・健康効果感を訴求 / C:毎日の健康のために続けられるを喚起',
    },
    {
      src: '/assets/migrated/0327e7085822f8ed9f20.webp',
      caption: '詳細訴求の展開コピーの考え方/抽出 — 「毎日に青汁のある食卓を キューサイ」/ A:栄養価が高い / B:はちみつで吸収力高い / C:飲みやすく続けやすい',
    },
    {
      src: '/assets/migrated/66096fb885a0d9fa0884.webp',
      caption: 'Q-SAI 青汁 プロモーション戦略プラン — 05',
    },
  ],
};

export default qSaiAojiruCase;